export function isValidEmailHandoff(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{1,63}$/.test(value);
}
